import { useState } from "react";
import { Modal, Group } from "@mantine/core";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Search from "../../assets/search.svg"
import Delete from "../../assets/delete.svg"
import { backendUrl } from "../../constants";
import moment from "moment";

const NewLocation = ({ opened, setOpened, searchHistory, setRefetch }) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));

  const handleDelete = (id) => {
    const options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-type": "application/json",
      },
    };
    fetch(`${backendUrl}user/deleteSearchHistory/${id}`, options)
      .then((response) => response.json())
      .then((response) => {
        setRefetch(true)
      })
      .catch((err) => console.error(err));
  };
  return (
    <>
      <Modal
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        title="Job Seeker History"
        overflow="inside"
      >
        <div className="searchHistory">
          {searchHistory.map((obj) => (
            <div className="d-flex gap-2 history-modal" key={obj.id}>
              <p style={{fontSize: '10px', marginBottom:'0px', marginRight:'20px'}}>{new moment( obj.date).format("DD MMM YY")}</p>
              <img src={Search} width="15px"/>
              <a href="/" className="text-decoration-none" style={{fontSize:'18px', color:'gray'}}>
                {obj.label}
              </a>
              <img src={Delete} width="15px" style={{marginLeft:'auto'}} className="delete" onClick={(v)=>handleDelete(obj.id)}/>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};
export default withTranslation()(NewLocation);
